export default class SideNavLinkController {

}
